import React from "react";
import PoktoolsState from "./PoktoolsState";

export const PoktoolsContext = React.createContext(new PoktoolsState());
